module.exports = __webpack_public_path__ + "static/media/shows.e6db2f35.svg";